Ext.define('SA.data.Projects', {
    singleton: true,

    initialize() {
        this.observable = new Ext.util.Observable();

        ['on', 'un', 'fireEvent'].forEach(method => {
            this[method] = (...args) => this.observable[method](...args);
        });

        SA.data.CustomLocations.on('update:locationItem', this.onCustomLocationUpdate, this);
    },

    createEmpty() {
        var allProjects = this.all,
            nameRoot = 'New Project',
            name = nameRoot,
            names = {},
            index = 2,
            project;

        allProjects.forEach(proj => {
            names[proj.getName()] = true;
        });

        for ( ; names[name] ; ++index) {
            name = nameRoot + ' ' + index;
        }

        project = new SA.data.Project({name});

        allProjects.unshift(project);

        return project;
    },

    delete(project) {
        var id = project.getId();

        project.erase();

        Ext.Array.remove(this.all, project);

        if (id) {
            SA.Ajax.request({method: 'delete', resource: 'user/projects', data: [id]});
        }
    },

    deserialize(data) {
        this.all = data
            .sort((a, b) => b.used - a.used)
            .map(project => new SA.data.Project(project));

        return this.all;
    },

    fireChangedViewBuildingBlock(view) {
        this.fireEvent('change:viewBuildingBlock', view);
    },

    fireRemovedView(view) {
        this.fireEvent('remove:view', view);
    },

    getAll() {
        return this.all;
    },

    getAllByLastViewed() {
        return this.all.slice();
    },

    getAllLocations() {
        return SA.Array.unique(this.all.map(project => project.getLocations()));
    },

    getAllReferencedAttributes() {
        return SA.Array.unique(this.all.map(project => project.getReferencedAttributes()));
    },

    getLastViewed() {
        return this.all[0];
    },

    getViewsOfType(type) {
        var allViews = SA.Array.flatMap(this.all, project => project.getViews());

        return allViews.filter(view => view.getType() === type);
    },

    hasMultipleProjects() {
        return this.all.length > 1;
    },

    hasSingleProject() {
        return this.all.length === 1;
    },

    onCustomLocationUpdate(location) {
        this.all.forEach(project => {
            project.onCustomLocationUpdate(location);
        });
    },

    onProjectViewed(project) {
        var all = this.all,
            index = all.indexOf(project);

        if (index === 0) {
            return;
        }

        all.splice(index, 1);
        all.unshift(project);
    },

    removeAttributes(attributes) {
        var promises = this.all.map(project => project.removeAttributes(attributes));

        return Promise.all(promises);
    }
});